import { types } from "../types/types";
const intitalState = {
    ourWork: [],
    ourWorkDetails: {},
};

const ourWorkReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.OUR_WORK_LIST:
            return {
                ...state,
                ourWork: action.payload,
            };
        case types.OUR_WORK_DETAILS:
            return {
                ...state,
                ourWorkDetails: action.payload,
            };
        default:
            return { ...state };
    }
};

export default ourWorkReducer;
